// Production backend. The old "-gules" alias still resolves but serves a stale
// deployment, so never fall back to it.
const DEFAULT_API_URL = 'https://samron-bot-backend.vercel.app';
const DEFAULT_LOCAL_API_URL = 'http://127.0.0.1:8003';

export const API_URL = (() => {
  const isLocalHost = typeof window !== 'undefined'
    && /localhost|127\.0\.0\.1/.test(window.location.hostname);
  if (isLocalHost) {
    // .env.local from Vercel CLI overrides REACT_APP_BACKEND_URL with production;
    // REACT_APP_DEV_BACKEND_URL in .env keeps local API routing explicit.
    const local = (
      process.env.REACT_APP_DEV_BACKEND_URL
      || process.env.REACT_APP_BACKEND_URL
      || DEFAULT_LOCAL_API_URL
    ).trim();
    if (local && !/vercel\.app/i.test(local)) {
      return local.replace(/\/$/, '');
    }
    return DEFAULT_LOCAL_API_URL;
  }
  const fromEnv = (process.env.REACT_APP_BACKEND_URL || '').trim();
  if (fromEnv) return fromEnv.replace(/\/$/, '');
  return DEFAULT_API_URL;
})();
